import { css } from '@bts-web/utils-style-engine';
import { RegularUpDownArrowsNoBackground } from '../../svgIcons/RegularUpDownArrowsNoBackground';
import { FC } from 'react';

export type FiatAssetSwitchProps = {
  onChange: () => void;
};

export const FiatAssetSwitch: FC<FiatAssetSwitchProps> = ({ onChange }) => {
  return (
    <div
      role="group"
      aria-label="switcher"
      data-testid="display-switch"
      onClick={() => onChange()}
      className={css({
        bgColor: 'neutrals.fill_focused',
        display: 'inline-flex',
        gap: 'extra_small_4',
        alignItems: 'center',
        p: 'extra_small_4',
        borderRadius: '100px',
        cursor: 'pointer',
      })}
    >
      <RegularUpDownArrowsNoBackground width={40} height={40} />
    </div>
  );
};
